import { render, staticRenderFns } from "./Religiousform.vue?vue&type=template&id=98f4e866"
import script from "./Religiousform.vue?vue&type=script&lang=js"
export * from "./Religiousform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports